import useSWR from 'hooks/useSWR';
import { CompanyCardDTO } from 'types/company';
import { List } from 'types/api';
import { useSWRResource } from 'util/resource/useSWRResource';
import { ShortlistedCompaniesParams, userAPIUrls } from './usersApi';

/** A company in the user's lists, with the lists it is in and when it was added. */
export interface ShortlistedCompanyCard {
  card: CompanyCardDTO;
  shortlistIds: UUID[];
  addedAt: DateString;
}

export const useShortlistedCompanies = (params: ShortlistedCompaniesParams) => {
  const swrResult = useSWR<List<ShortlistedCompanyCard>>(userAPIUrls.shortlists.companies(params));
  return useSWRResource(swrResult);
};

/** Companies the user doesn't know yet that are like the ones in the list. */
export const useShortlistSuggestions = (shortlistId: UUID) => {
  const swrResult = useSWR<CompanyCardDTO[]>(userAPIUrls.shortlists.suggestions(shortlistId));
  return useSWRResource(swrResult);
};
